import { createContext, useContext, useState } from 'react';

// Create context
export const AuthFormContext = createContext(null);

// Custom hook for using the context
export const useAuthForm = () => {
  const context = useContext(AuthFormContext);
  if (!context) {
    throw new Error('useAuthForm must be used within an AuthFormProvider');
  }
  return context;
};

// Provider component
export const AuthFormProvider = ({ children }) => {
  const [formData, setFormData] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submissionError, setSubmissionError] = useState(null);
  
  // Store the submission handler function
  const [handleSubmitCallback, setHandleSubmitCallback] = useState(() => () => {
    console.warn('Submit handler not initialized yet');
  });
  
  // Method to register the submit handler from JobSearchForm
  const registerSubmitHandler = (handler) => {
    setHandleSubmitCallback(() => handler);
  };
  
  // Method to trigger form submission from anywhere
  const triggerSubmit = async () => {
    try {
      setIsSubmitting(true);
      await handleSubmitCallback();
    } catch (error) {
      console.error('Error during form submission:', error);
      setSubmissionError(error.message || 'Form submission failed');
    } finally {
      setIsSubmitting(false);
    }
  };
  
  const value = {
    formData,
    setFormData,
    isSubmitting,
    setIsSubmitting,
    submissionError,
    setSubmissionError,
    registerSubmitHandler,
    triggerSubmit
  };
  
  return (
    <AuthFormContext.Provider value={value}>
      {children}
    </AuthFormContext.Provider>
  );
}; 